export const CATEGORY_LAYOUTS = {
  NORMAL:  'normal',
  SPECIAL: 'special',
};

export const CATEGORY_SPECIAL_TYPES = {
  VIRTUAL:   'virtual',
  DART_CARD: 'dart-card',
};

// 純前端顯示設定，不存後端
export const CATEGORY_DISPLAY = {
  barrel:      { layout: 'normal', tone: 'ink',   num: '01', svg: 'dart-barrel', viewBox: '0 0 80 360',  svgHeight: 200, specialType: null, linkTo: null,         badge: null  },
  flight:      { layout: 'normal', tone: 'steel', num: '02', svg: 'dart-flight', viewBox: '0 0 220 360', svgHeight: 200, specialType: null, linkTo: null,         badge: null  },
  shaft:       { layout: 'normal', tone: 'navy',  num: '03', svg: 'dart-shaft',  viewBox: '0 0 80 360',  svgHeight: 200, specialType: null, linkTo: null,         badge: null  },
  tip:         { layout: 'normal', tone: 'gold',  num: '04', svg: 'dart-tip',    viewBox: '0 0 80 360',  svgHeight: 200, specialType: null, linkTo: null,         badge: null  },
  set:         { layout: 'normal', tone: 'navy',  num: '05', svg: 'dart-full',   viewBox: '0 0 200 600', svgHeight: 210, specialType: null, linkTo: null,         badge: null  },
  virtual:     { layout: 'special', tone: null,   num: '06', svg: null,           viewBox: null,          svgHeight: null, specialType: 'virtual',   linkTo: '/virtual',   badge: 'NEW' },
  'dart-card': { layout: 'special', tone: null,   num: '07', svg: null,           viewBox: null,          svgHeight: null, specialType: 'dart-card', linkTo: '/shop?category=dart-card', badge: null  },
};

// Mock 資料（沒有 REACT_APP_API_BASE_URL 時使用）
export const CATEGORIES = [
  { id: 'barrel',    name: '標身', en: 'BARREL', displayOrder: 1, active: true },
  { id: 'flight',    name: '標翼', en: 'FLIGHT', displayOrder: 2, active: true },
  { id: 'shaft',     name: '標桿', en: 'SHAFT',  displayOrder: 3, active: true },
  { id: 'tip',       name: '標針', en: 'TIP',    displayOrder: 4, active: true },
  { id: 'set',       name: '套組', en: 'SET',    displayOrder: 5, active: true },
  { id: 'virtual',   name: '虛擬商品', en: 'VIRTUAL · D2 / D3 主題 · Fun Dart', displayOrder: 6, active: true },
  { id: 'dart-card', name: '飛鏢機卡', en: 'DARTSLIVE · PHOENICA CARD',          displayOrder: 7, active: true },
];

// Mock 資料
export const BRANDS = [
  { id: 'TARGET',   name: 'TARGET' },
  { id: 'DYNASTY',  name: 'DYNASTY' },
  { id: 'COSMO',    name: 'COSMO DARTS' },
  { id: 'L-style',  name: 'L-style' },
  { id: 'FIT',      name: 'FIT' },
];
